{
  "Empty": "Изпразни"
}
